import { queryOptions } from '@tanstack/react-query';

import { getMarketingCampaignAllQuery, getMarketingCampaignQuery } from './shared';

export const getMarketingCampaignQueryOptions = (id: string) => queryOptions(getMarketingCampaignQuery(id));
export const getMarketingCampaignAllQueryOptions = () => queryOptions(getMarketingCampaignAllQuery());
